var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-layout',{attrs:{"processing":_vm.processing,"resetProcessed":_vm.resetProcessed,"resetError":_vm.resetError},on:{"processed":_vm.processReset}})}
var staticRenderFns = []

export { render, staticRenderFns }